import React from "react";
import { Route, RouteSwitch } from "@hex-insights/router";
import { EmployeeDetailQuery } from "../../../../../Utilities";
import { DetailRouteContext } from "../RouteContext";
import { AcademicsBody } from "./Academics";
import { OverviewBody } from "./Overview";

export type BodyProps = {
	employee: EmployeeDetailQuery["employee"];
};

export function Body({ employee }: BodyProps) {
	const { subPageInfos } = React.useContext(DetailRouteContext);

	return (
		<RouteSwitch>
			<Route {...subPageInfos.overview.routeProps}>
				<OverviewBody employee={employee} />
			</Route>
			<Route {...subPageInfos.academics.routeProps}>
				<AcademicsBody employee={employee} />
			</Route>
		</RouteSwitch>
	);
}
